export default {
  en: {
    '帮助分类': 'Help categories',
    '查看详情': 'View details',
    '关闭帮助中心': 'Close Help Center',
    '换一个关键词试试，或联系在线客服。': 'Try another keyword or contact online support.',
    '没有找到答案？': 'Couldn’t find an answer?',
    '没有找到相关问题': 'No matching questions found',
    '清空搜索': 'Clear search',
    '搜索帮助中心问题': 'Search Help Center questions',
    '搜索问题关键词...': 'Search question keywords…',
    '查看视频教程': 'View video guide',
    '策略运行': 'Strategy operation',
    '费用与资金': 'Fees and funds',
    '基础说明': 'Basics',
    '合约策略浮亏说明': 'Contract strategy unrealized-loss explanation',
    '打开视频查看Binance交易所API绑定开通流程。': 'Open the video to view the Binance API binding process.',
    '打开视频查看Gate交易所API绑定开通流程。': 'Open the video to view the Gate API binding process.',
    '打开视频查看OKx交易所API绑定开通流程。': 'Open the video to view the OKX API binding process.',
    '1、添加策略。': '1. Add a strategy.',
    '（1）设置参数，例如设置投入策略的USDT金额：600 USDT。': '(1) Set parameters, for example, invest 600 USDT in the strategy.',
    '（2）策略运行。对冲合约交易为全自动策略，无需手动干预，运行中可能有浮亏，为避免产生不必要的亏损，请谨慎操作。收益将自动划转至交易所的资金账户。': '(2) Run the strategy. Hedged contract trading is fully automated and requires no manual intervention. Unrealized losses may occur, so operate carefully. Earnings are transferred automatically to the exchange funding account.',
    '2、点击机器人页面 > 开启机器人，机器人处于启动状态即为开启成功。': '2. On the Bots page, click Start Bot. The bot is ready when its status is active.',
    '1、打开欧易APP，点击中间“交易”。': '1. Open the OKX app and tap “Trade.”',
    '2、在交易页面点击右上角图标。': '2. Tap the icon in the upper-right corner of the trading page.',
    '3、找到“交易设置”，点击“交易设置”。': '3. Find and open “Trading settings.”',
    '4、找到“账户模式”，修改为“合约模式”并点击“切换”，新用户会跳转到答题页面。': '4. Find “Account mode,” change it to contract mode, and tap “Switch.” New users will be taken to a quiz.',
    'Binance用户点击“合约”，再点击“开通合约账户”，完成答题后即可进行合约交易。': 'Binance users should open “Contracts,” select “Open contract account,” and complete the quiz to enable contract trading.',
    '2、在浏览器打开的交易所创建API Key(如已创建，请忽略此步)。': '2. Create an API Key on the exchange in your browser (skip if already created).',
    '3、打开UPlus APP绑定使用的交易所API，输入API生成的接口信息。': '3. Open UPlus, bind the exchange API, and enter the generated API information.',
    'OKX、Binance、Gate.io和Bybit创建API Key时，请按教程勾选重要参数和可用权限。': 'When creating an API Key on OKX, Binance, Gate.io, or Bybit, select the required parameters and permissions shown in the guide.',
    '1、进入我的页面 > 点击总资产或者资金账户、交易账户任意位置进入我的资产详情。': '1. Open My, then tap Total Assets, Funding Account, or Trading Account to open asset details.',
    '1、点击我的 > 购买点卡，或者点击我的 > 钱包总资产页面 > 购买。': '1. Tap My > Buy Points, or My > Wallet Total Assets > Buy.',
    '3、充值完成后币是存放在资金账户，需要划转后才可以用于机器人运行。点击划转，输入转入数量，确定后即可完成划转。': '3. Deposited funds are stored in the funding account. Transfer them to the fuel account before running a bot. Tap Transfer, enter the amount, and confirm.',
    '2.请谨慎在交易所手动挪用资金，划转后会导致机器人交易异常，无法正常开单，严重情况会有爆仓风险。': '2. Do not manually move funds on the exchange. Doing so may disrupt bot orders and, in severe cases, cause liquidation.',
    '币安专属用户：2020年5月1日以后注册的币安账户并且未绑定其它平台邀请码，即可校验成功成为UPLUS专属用户。': 'Binance exclusive users: Binance accounts registered after May 1, 2020 that have not used another platform’s invitation code can be verified as UPLUS exclusive users.',
    '风险等级越高，收益和风险越高，风险等级越低，收益越低越稳定；': 'Higher risk levels mean higher potential returns and risk; lower risk levels provide lower but more stable returns.',
    '若仓位足够则默认风险等级为70%，仓位越大可调的风险等级范围越大，仓位越小可调的风险等级越小；': 'With sufficient position size, the default risk level is 70%. Larger positions allow a wider adjustable range; smaller positions allow a narrower range.',
    '请注意，当前策略风险等级设置后不可修改，如需修改需创建新的策略 !': 'Note: a strategy’s risk level cannot be changed after creation. Create a new strategy to use a different level.',
    '交易所历史订单里为什么会有亏损平仓，是不是多扣费了？': 'Why do exchange order records show closes at a loss? Was an extra fee charged?'
  },
  ko: {
    '帮助分类': '도움말 분류',
    '查看详情': '상세 보기',
    '关闭帮助中心': '도움말 센터 닫기',
    '换一个关键词试试，或联系在线客服。': '다른 키워드로 검색하거나 온라인 고객 지원에 문의하세요.',
    '没有找到答案？': '답을 찾지 못하셨나요?',
    '没有找到相关问题': '관련 질문을 찾지 못했습니다',
    '清空搜索': '검색 지우기',
    '搜索帮助中心问题': '도움말 센터 질문 검색',
    '搜索问题关键词...': '질문 키워드 검색…',
    '查看视频教程': '동영상 가이드 보기',
    '策略运行': '전략 운영',
    '费用与资金': '수수료 및 자금',
    '基础说明': '기본 설명',
    '合约策略浮亏说明': '계약 전략 미실현 손실 설명',
    '打开视频查看Binance交易所API绑定开通流程。': '동영상을 열어 Binance API 연결 과정을 확인하세요.',
    '打开视频查看Gate交易所API绑定开通流程。': '동영상을 열어 Gate API 연결 과정을 확인하세요.',
    '打开视频查看OKx交易所API绑定开通流程。': '동영상을 열어 OKX API 연결 과정을 확인하세요.',
    '1、添加策略。': '1. 전략을 추가합니다.',
    '（1）设置参数，例如设置投入策略的USDT金额：600 USDT。': '(1) 예를 들어 전략 투자 금액을 600 USDT로 설정합니다.',
    '（2）策略运行。对冲合约交易为全自动策略，无需手动干预，运行中可能有浮亏，为避免产生不必要的亏损，请谨慎操作。收益将自动划转至交易所的资金账户。': '(2) 전략을 실행합니다. 헤지 계약 거래는 완전 자동이며 수동 개입이 필요하지 않습니다. 미실현 손실이 발생할 수 있으므로 신중하게 운용하세요. 수익은 거래소 자금 계정으로 자동 이체됩니다.',
    '2、点击机器人页面 > 开启机器人，机器人处于启动状态即为开启成功。': '2. 봇 페이지에서 봇 시작을 누릅니다. 활성 상태가 되면 시작이 완료된 것입니다.',
    '1、打开欧易APP，点击中间“交易”。': '1. OKX 앱을 열고 가운데의 “거래”를 누릅니다.',
    '2、在交易页面点击右上角图标。': '2. 거래 페이지 오른쪽 위 아이콘을 누릅니다.',
    '3、找到“交易设置”，点击“交易设置”。': '3. “거래 설정”을 찾아 누릅니다.',
    '4、找到“账户模式”，修改为“合约模式”并点击“切换”，新用户会跳转到答题页面。': '4. “계정 모드”를 계약 모드로 변경하고 “전환”을 누릅니다. 신규 사용자는 퀴즈 화면으로 이동합니다.',
    'Binance用户点击“合约”，再点击“开通合约账户”，完成答题后即可进行合约交易。': 'Binance 사용자는 “계약”을 누른 뒤 “계약 계정 개설”을 선택하고 퀴즈를 완료하면 계약 거래를 이용할 수 있습니다.',
    '2、在浏览器打开的交易所创建API Key(如已创建，请忽略此步)。': '2. 브라우저에서 거래소 API Key를 생성합니다(이미 생성했다면 건너뛰세요).',
    '3、打开UPlus APP绑定使用的交易所API，输入API生成的接口信息。': '3. UPlus에서 거래소 API를 연결하고 생성된 API 정보를 입력합니다.',
    'OKX、Binance、Gate.io和Bybit创建API Key时，请按教程勾选重要参数和可用权限。': 'OKX, Binance, Gate.io, Bybit에서 API Key를 만들 때 가이드에 표시된 필수 매개변수와 권한을 선택하세요.',
    '1、进入我的页面 > 点击总资产或者资金账户、交易账户任意位置进入我的资产详情。': '1. 내 페이지에서 총자산, 자금 계정 또는 거래 계정을 눌러 자산 상세로 이동합니다.',
    '1、点击我的 > 购买点卡，或者点击我的 > 钱包总资产页面 > 购买。': '1. 내 페이지 > 포인트 구매 또는 내 페이지 > 지갑 총자산 > 구매를 누릅니다.',
    '3、充值完成后币是存放在资金账户，需要划转后才可以用于机器人运行。点击划转，输入转入数量，确定后即可完成划转。': '3. 충전한 자금은 자금 계정에 보관됩니다. 봇 운영 전에 연료 계정으로 이체하세요. 이체를 누르고 금액을 입력한 뒤 확인합니다.',
    '2.请谨慎在交易所手动挪用资金，划转后会导致机器人交易异常，无法正常开单，严重情况会有爆仓风险。': '2. 거래소에서 자금을 수동으로 이동하지 마세요. 봇 주문이 비정상적으로 동작하고 심한 경우 강제 청산될 수 있습니다.',
    '币安专属用户：2020年5月1日以后注册的币安账户并且未绑定其它平台邀请码，即可校验成功成为UPLUS专属用户。': 'Binance 전용 사용자: 2020년 5월 1일 이후 가입하고 다른 플랫폼 초대 코드를 사용하지 않은 Binance 계정은 UPLUS 전용 사용자로 인증할 수 있습니다.',
    '风险等级越高，收益和风险越高，风险等级越低，收益越低越稳定；': '위험 등급이 높을수록 잠재 수익과 위험이 높고, 낮을수록 수익은 낮지만 안정적입니다.',
    '若仓位足够则默认风险等级为70%，仓位越大可调的风险等级范围越大，仓位越小可调的风险等级越小；': '포지션이 충분하면 기본 위험 등급은 70%입니다. 포지션이 클수록 조정 범위가 넓고 작을수록 좁습니다.',
    '请注意，当前策略风险等级设置后不可修改，如需修改需创建新的策略 !': '주의: 전략 위험 등급은 설정 후 변경할 수 없습니다. 변경하려면 새 전략을 생성하세요.',
    '交易所历史订单里为什么会有亏损平仓，是不是多扣费了？': '거래소 과거 주문에 손실 청산이 표시되는 이유는 무엇이며 추가 수수료가 부과된 건가요?'
  }
}
